(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"]) return;
  try {
    
  document.querySelectorAll('[data-collection-description-toggle]').forEach(function (btn) {
    if (btn.dataset.readmoreBound === 'true') return;
    btn.dataset.readmoreBound = 'true';
    btn.addEventListener('click', function () {
      var root = btn.closest('[data-collection-description]');
      if (!root) return;
      var short = root.querySelector('[data-collection-description-short]');
      var full = root.querySelector('[data-collection-description-full]');
      if (!short || !full) return;
      short.hidden = true;
      full.hidden = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-testimonials]').forEach(function (section) {
    if (section.dataset.testimonialsBound === 'true') return;
    section.dataset.testimonialsBound = 'true';

    var slides = section.querySelectorAll('[data-testimonial-slide]');
    var dotsContainer = section.querySelector('[data-testimonial-dots]');
    if (slides.length === 0 || !dotsContainer) return;

    var dots = [];
    slides.forEach(function (slide, index) {
      if (index === 0) slide.classList.add('is-active');

      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'testimonials__dot' + (index === 0 ? ' is-active' : '');
      dot.setAttribute('data-testimonial-dot', index);
      dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
      dotsContainer.appendChild(dot);
      dots.push(dot);
    });

    if (slides.length <= 1) {
      dotsContainer.style.display = 'none';
      return;
    }

    var current = 0;
    function showSlide(index) {
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      dots.forEach(function (d) { d.classList.remove('is-active'); });
      slides[index].classList.add('is-active');
      if (dots[index]) dots[index].classList.add('is-active');
      current = index;
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        showSlide(parseInt(dot.dataset.testimonialDot, 10));
      });
    });

    var intervalId = window.setInterval(function () {
      if (!document.body.contains(section)) {
        window.clearInterval(intervalId);
        return;
      }
      showSlide((current + 1) % slides.length);
    }, 5000);
  });

  } catch(e) { console.error(e); }
})();
})();
